import { handleError } from "../Helpers/ErrorHandler";
import { Bank } from "../Models/Banks";
import { mapStringToLinkPaymentStatus } from "../Models/LinkPaymentStatus";
import { PaymentType } from "../Models/PaymentType";
import {
  mapStringToRecurringInstructStatus,
  RecurringInstructStatus,
} from "../Models/RecurringInstructStatus";
import { LinkPaymentsResponse } from "../Models/response/LinkPaymentsResponse";
import { LinkPaymentsStatusResponse } from "../Models/response/LinkPaymentsStatusResponse";
import axiosInstance from "./Axios";

export const getBanks = async () => {
  try {
    const response = await axiosInstance.get<Bank[]>("/banks");
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export interface PaymentProps {
  type: PaymentType;
  amount?: number;
  creditId?: number;
  snoozeDays?: number;
  previewId?: string;
}

export const bulkAndSinglePaymentLinkGenerate = async (props: PaymentProps): Promise<LinkPaymentsResponse | undefined> => {
  try {
    const response = await axiosInstance.post("/checkout/link-payments", {
      type: props.type,
      amount: props.amount,
      snoozeDays: props.snoozeDays,
      creditId: props.creditId,
      previewId: props.previewId,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const checkBulkAndSinglePaymentLinkStatus = async (token: string): Promise<LinkPaymentsStatusResponse | undefined> => {
  try {
    const response = await axiosInstance.get(`/checkout/link-payments/${token}/status`);
    const status = mapStringToLinkPaymentStatus(response.data.status);
    return { status: status };
  } catch (error) {
    handleError(error);
  }
};

export const masterpassRecurringInit = async (phoneNumber: string) => {
  try {
    const response = await axiosInstance.post("/masterpass/recurring-payment", {
    //const response = await axiosInstance.post("/checkout/masterpass/recurring-init", {
      phoneNumber: phoneNumber
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const masterpassRecurringCheck = async (token: string): Promise<RecurringInstructStatus | undefined> => {
  try {
    const response = await axiosInstance.get<{ status?: string }>(
      `/masterpass/recurring-payment/${token}/status`
    );
    const raw = response.data?.status;
    if (raw == null || raw === "") {
      return undefined;
    }
    return mapStringToRecurringInstructStatus(raw);
  } catch (error) {
    handleError(error);
  }
};